import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { SEGMENT_BY_SLUG } from "@/lib/segments";
import SegmentRoute from "@/pages/SegmentRoute";

export const Route = createFileRoute("/agente-ia-clinica")({
  head: () => buildHead({
    title: SEGMENT_BY_SLUG["agente-ia-clinica"]!.metaTitle,
    description: SEGMENT_BY_SLUG["agente-ia-clinica"]!.metaDescription,
    path: "/agente-ia-clinica",
  }),
  component: () => <SegmentRoute slug="agente-ia-clinica" />,
});
